import type {ReactElement} from 'react';
import React, {useEffect, useState} from 'react';
import {DigitalSignageSubPanel} from '@Panels/poster-publishing-options-panel/components/publishing-digital-signage-list/components/digital-signage-sub-panel/digital-signage-sub-panel';
import {setErrorMessageForPublishing, setErrorOnPublishPanel} from '@Panels/poster-publishing-options-panel/poster-publishing-options-slice';
import {useAppDispatch} from '@/hooks';
import type {PublishingSmartTvPanelProps} from './publishing-smart-tv-panel.types';
import {getProductUsed} from '@Panels/poster-publishing-options-panel/poster-publishing-options-panel-library';
import {useCopyButton} from '@Panels/poster-publishing-options-panel/components/publishing-digital-signage-list/publishing-digital-signage-list.hooks';
import {noop} from '@Utils/general.util';

export function PublishingSmartTvPanel({...props}: PublishingSmartTvPanelProps): ReactElement<any> {
  const [displayCode, setDisplayCode] = useState('');
  const [copied, setCopied] = useState(false);
  const dispatch = useAppDispatch();
  const productUsed = getProductUsed();

  useEffect(() => {
    if (displayCode === '') {
      void window.PMW.readLocal('v/generateDisplayCode', {
        orderId: productUsed?.orderId,
      })
        .then((response: string) => {
          setDisplayCode(response);
        })
        .catch(() => {
          dispatch(setErrorOnPublishPanel(true));
          dispatch(setErrorMessageForPublishing(window.i18next.t('pmwjs_error_message')));
        });
    }
  }, [displayCode]);

  return (
    <DigitalSignageSubPanel
      panelHeading={window.i18next.t('pmwjs_smart_tv')}
      heading={window.i18next.t('pmwjs_play_on_smart_tv')}
      subheading={window.i18next.t('pmwjs_play_on_smart_tv_desc')}
      showInputBar
      onClose={props.onClose}
      inputBarIcon="icon-link"
      webpageLink={window.PMW.util.site_url(`v/d/${displayCode}`)}
      showButton
      buttonComponent={useCopyButton(copied, window.PMW.util.site_url(`v/d/${displayCode}`), setCopied, noop)}
    />
  );
}
